var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card-check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.3333 14.9993L15 16.666L18.3333 13.3327M18.3333 8.33268H1.66663M18.3333 9.99935V6.83268C18.3333 5.89926 18.3333 5.43255 18.1516 5.07603C17.9918 4.76243 17.7369 4.50746 17.4233 4.34767C17.0668 4.16602 16.6 4.16602 15.6666 4.16602H4.33329C3.39987 4.16602 2.93316 4.16602 2.57664 4.34767C2.26304 4.50746 2.00807 4.76243 1.84828 5.07603C1.66663 5.43255 1.66663 5.89926 1.66663 6.83268V13.166C1.66663 14.0994 1.66663 14.5661 1.84828 14.9227C2.00807 15.2363 2.26304 15.4912 2.57664 15.651C2.93316 15.8327 3.39987 15.8327 4.33329 15.8327H9.99996",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDCard);
export default __webpack_public_path__ + "static/media/d-card.706718b3a7e62aed46d7227ccc94efb1.svg";
export { ForwardRef as ReactComponent };